import { Link } from "gatsby"
import React from "react"
import { Col, Row } from "react-bootstrap"

const PrivacyPolicy1 = () => {
  return (
    <section id="terms-section1" className="position-relative py-5 mt-5">
      <div className="container py-4">
        <Row>
          <Col md="12">
            <h1 className="mt-5 mb-5">Privacy Policy</h1>
            <h5>
              <strong>SuperBetter Privacy Principles</strong>
            </h5>
            <p>
              Our approach to privacy and security is guided by the following
              principles:
            </p>
            <ol>
              <li>
                We are committed to creating a secure and safe digital
                environment.
              </li>
              <li>We take the protection of personal information seriously.</li>
              <li>We never sell personal information to third parties.</li>
              <li>We do not generate revenue by selling in-app advertising.</li>
              <li>We take extra precautions for youth under age 13.</li>
            </ol>
            <h5>
              <strong>Privacy Policy Overview</strong>
            </h5>
            <p>
              SuperBetter is committed to protecting the privacy and security of
              our users, and being transparent about how we use information
              collected. This Privacy Policy is meant to help you understand how
              we collect and use personal information you provide when you use
              our SuperBetter website (“Website”), mobile and web applications
              (“Apps”) and related services (together, the “Service”).
            </p>
            <p>This policy explains:</p>
            <ul>
              <li>Information we collect</li>
              <li>How information is used</li>
              <li>Situations where information might be shared</li>
              <li>How we protect your personal information</li>
            </ul>
            <h5>
              <strong>Information We Collect and Sources</strong>
            </h5>
            <p>
              We collect certain information about you to provide you with the
              Service or the support you request. The type of information we
              collect can vary depending on how you access and use our Service.
              Additionally, you can choose to voluntarily provide information to
              us. Below we have described the types of information we collect
              and from where we collect it.
            </p>
            <h5>
              <strong>Information you Provide to Use the Service</strong>
            </h5>
            <p>
              <strong>Account information.</strong> We collect the information
              you provide when you sign up for a SuperBetter account, log in to
              your account, communicate with us, upload content, or otherwise
              use the Service. We request an email address and date of birth
              when you choose to sign up for the Service so we can provide the
              Services to you and allow us to comply with applicable
              regulations. For example, the date of birth is used to determine
              whether you are under the age of 13 so that we can facilitate the
              required approval to create an account in compliance with COPPA
              regulations.
            </p>
            <p>
              <strong>Transactional information.</strong> Users who engage in
              financial transactions with SuperBetter, for example to purchase a
              subscription, are asked to provide additional information in order
              to complete the transaction, such as a credit card number, billing
              address and full name. Visitors can always refrain from supplying
              certain information, but it may prevent them from engaging in
              certain SuperBetter services which require that information.
            </p>

            <h5>
              <strong>
                Information You Provide to Enhance Your Experience
              </strong>
            </h5>
            <p>
              You can choose to provide us with additional information in order
              to obtain a better user experience when using the Service. This
              additional information will be processed with your consent and/or
              to provide you with services you request. This information may
              include survey responses, participation in contests, promotions or
              other marketing efforts, suggestions for improvements, referrals,
              or any other actions on the Service.
            </p>
            <h5>
              <strong>
                Information We Get Automatically When You Use the Service
              </strong>
            </h5>
            <p>
              We automatically collect information about you and how you use the
              Service. This information includes:
            </p>
            <p>
              <strong>Device information:</strong> Like most website operators,
              SuperBetter collects information about how users visit our site
              and the devices they use. We collect device-specific information
              (such as your hardware model, operating system version, device
              identifiers like IDFA and UDID, and mobile network information).
              SuperBetter may associate your device identifiers or other device
              information with your SuperBetter Account to help us provide
              consistent services across your devices.
            </p>
            <p>
              <strong>Geolocation information:</strong> We may use your IP
              address to generate a general approximation of where you are
              located in order to provide you with an improved experience. We do
              not request access to or collect location sensor information, such
              as GPS or Bluetooth beacons, from your mobile device while
              downloading or using our mobile apps or services.
            </p>
            <p>
              <strong>Log information:</strong> When you use SuperBetter, we
              automatically collect and store certain information about this
              activity. This data includes details of how you used our service,
              like your search queries, clicks, navigation information, or
              activities. It also may include data such as:
            </p>
            <ul>
              <li>Browser type</li>
              <li>Language preference and time zone</li>
              <li>
                {" "}
                Referring site, and the date and time of each visitor request
              </li>
              <li>Connection information like ISP or mobile operator</li>
              <li>Internet Protocol (IP) address</li>
              <li>Log-in and Log-out times</li>
            </ul>
            <h5>
              <strong>Information We Collect From Other Sources</strong>
            </h5>
            <p>Information we collect about you from third parties includes:</p>
            <p>
              <strong>Google, Apple and Facebook Login:</strong> You have the
              option to log in to our Service using sign-in services such as
              Google Login, Apple Login and Facebook Connect. These services
              authenticate your identity and provide you the option to share
              certain personal information with us, such as your name, date of
              birth, and email address, to facilitate the creation of your
              account.
            </p>
            <p>
              <strong>Other users:</strong> SuperBetter may receive information
              about you from other users. For example, a host may add your email
              address to their account in order to invite you to join a Squad
              Challenge.
            </p>
            <p>
              <strong>Other partners and companies:</strong> SuperBetter may
              also receive information about you from other sources, including
              our partners, service providers or other third parties.
            </p>
            <h5>
              <strong>Information From Children</strong>
            </h5>
            <p>
              Children under the age of 13 require the approval of their parent,
              guardian or teacher to create an account to play SuperBetter. To
              create an account to play the Service, SuperBetter requires the
              user to submit a date of birth, username and email address. If a
              user is under the age of 13, they are required to also provide an
              email address for their parent, guardian, or teacher. The parent,
              guardian teacher is then sent an email and must approve the
              account before the account can be created.
            </p>
            <p>
              We do not sell personal information from accounts of children (or
              anyone else). We may share or distribute information as described
              in this section and this Privacy Notice, including with parents,
              guardians or teachers to gather consent to create an account, and
              with third parties to support internal operations related to
              providing the Service. We may use aggregated or de-identified
              information about children for research, analysis and other
              commercial purposes.
            </p>
            <h5>
              <strong>How We Use Your Information</strong>
            </h5>
            <p>
              We collect information about you when you use the Service for a
              variety of reasons in order to support SuperBetter and to enable
              our team to continue to create engaging and effective experiences
              for our users.
            </p>
            <h5>
              <strong>
                Providing, Analyzing, Improving and Developing the Service
              </strong>
            </h5>
            <p>
              We process the data we collect about you to operate, improve and
              develop the Service, including providing, maintaining, securing
              and improving our services, developing new ones, and protecting
              SuperBetter and our users. We are able to deliver our services,
              personalize content, and make suggestions for you by using this
              information to understand how you use and interact with our
              services. We may conduct surveys and research, test features in
              development, and analyze the information we have to evaluate and
              improve products and services, develop new products or features,
              and conduct audits and troubleshooting activities.
            </p>
            <p>Here are some examples of how we use this information:</p>
            <ul>
              <li>
                <p>
                  <strong>
                    Providing, maintaining and improving the Service:{" "}
                  </strong>{" "}
                  Account information we collect from you allows us to help you
                  log in, choose Challenges, host Challenges, complete
                  activities and use other features. It also allows us to learn
                  about how you and others use SuperBetter to inform the design
                  of new services.
                </p>
              </li>
              <li>
                <p>
                  <strong>
                    Improving, personalizing and facilitating your use of the
                    Service:
                  </strong>{" "}
                  When you sign up and use a SuperBetter account, we may
                  associate certain information with your new account, such as
                  information about other SuperBetter accounts you had or
                  currently have, and your prior usage of the Service. For
                  example, we may use information collected from cookies and
                  other technologies, like pixel tags, to save your language
                  preferences, so we will be able to have our services appear in
                  the language you prefer. We do this in order to ensure that
                  content from the Service is presented in the most effective
                  manner for you.
                </p>
              </li>
              <li>
                <p>
                  <strong>
                    {" "}
                    Measuring, tracking and analyzing trends and usage in
                    connection with your use or the performance of the Service:
                  </strong>{" "}
                  In order to develop and enhance our products and deliver a
                  consistent, secure and continuous experience, we need to
                  gather certain information to analyze usage and performance of
                  the Service. We also use web and mobile analytics software to
                  pursue our legitimate interests in operating and improving
                  SuperBetter by allowing us to better understand the
                  functionality of our mobile software on your device. This
                  software may record information such as how often you use the
                  application, the events and activities that occur within the
                  application, aggregated usage, performance data, and where the
                  application was downloaded from.
                </p>
              </li>
              <li>
                <p>
                  <strong>
                    Fulfilling any other purpose disclosed to you in connection
                    with the Service.
                  </strong>
                </p>
              </li>
            </ul>
            <h5>
              <strong> Communicating with You About the Service</strong>
            </h5>
            <p>
              We also use your account information and information you provide
              to us to provide you with relevant information about the Service
              and to assist you in using the Service if required. These
              communications may include:
            </p>
            <ul>
              <li>
                <p>
                  <strong>
                    Sending you information about your account or the Service:
                  </strong>{" "}
                  We may send updates about changes to the Service that impact
                  your SuperBetter account. We expect to keep this type of email
                  to a minimum.
                </p>
              </li>
              <li>
                <p>
                  <strong>
                    Conducting surveys and collecting feedback about the
                    Service:
                  </strong>{" "}
                  We do this to evaluate the effectiveness of any updates we
                  provide.
                </p>
              </li>
              <li>
                <p>
                  <strong>
                    Delivering assistance or answering support requests:
                  </strong>{" "}
                  We send you the information and support you request, including
                  technical notices, security alerts, and other administrative
                  messages to provide assistance for problems you may encounter
                  with the Service or your account.
                </p>
              </li>
            </ul>
            <h5>
              <strong>
                Protecting the Service and Maintaining a Trusted Environment
              </strong>
            </h5>
            <p>
              We use all categories of information we collect to maintain
              SuperBetter as a safe and secure platform for all our users,
              including appropriate enforcement of SuperBetter policies, as well
              as compliance with the law and applicable regulations. These
              efforts include:
            </p>
            <ul>
              <li>
                <p>
                  <strong>
                    Preventing fraud, crime and abuse and the security and
                    integrity of the Service:
                  </strong>{" "}
                  This includes investigating, detecting and preventing or
                  reporting fraud, misrepresentations, security breaches or
                  incidents, other potentially prohibited or illegal activities
                  or to otherwise help protect your account.
                </p>
              </li>
              <li>
                <p>
                  <strong>Enforcing our Terms of Service.</strong>
                </p>
              </li>
              <li>
                <p>
                  <strong>Verifying your identity:</strong> In some cases, we
                  may need to verify your identity in order to protect the
                  security and integrity of the Service and your account.
                </p>
              </li>
              <li>
                <p>
                  <strong>
                    Complying with any applicable laws or regulations:
                  </strong>{" "}
                  This includes appropriately responding to lawful requests for
                  information from the government or third parties through legal
                  process.
                </p>
              </li>
              <li>
                <p>
                  <strong>
                    Contacting you to provide assistance with the Service,
                    collect fees and resolve disputes.
                  </strong>
                </p>
              </li>
            </ul>
            <h5>
              <strong>Advertising, Analytics and Marketing</strong>
            </h5>
            <p>
              In order to support the SuperBetter business and provide our users
              with relevant information regarding the Service and opportunities
              presented by partners, SuperBetter may use your personal
              information for marketing the Service. We may also communicate
              with you and others about products, services, opportunities,
              contests, promotions, discounts, incentives, surveys, and rewards.
            </p>
            <h5>
              <strong>Cookies and Other Similar Technologies</strong>
            </h5>
            <p>
              Technologies such as cookies, beacons, tags and scripts may be
              used by SuperBetter, partners, and analytics and service
              providers. These are used to collect and store data about users in
              order to provide the Service in accordance with our agreement with
              you under the Terms of Service and allow SuperBetter to pursue our
              interests in operating and improving the Service.
            </p>
            <h5>
              <strong>Information We Combine</strong>
            </h5>
            <p>
              We also collect some information from other sources and combine
              that with information we collect from you. To ensure a proper
              experience on SuperBetter, we may combine information collected
              across devices, such as computers and mobile devices.
            </p>
            <h5>
              <strong>Other Uses</strong>
            </h5>
            <p>
              We may process data for any other purpose disclosed to you in
              connection with the Service from time to time. If we intend to
              process your personal data for a purpose other than that set out
              above and which is not compatible with the original processing
              purpose, we will provide you with relevant information prior to
              such processing and will obtain your consent where necessary.
            </p>
            <h5>
              <strong>How your Information Is Shared</strong>
            </h5>
            <h5>
              <strong>Information You Share on SuperBetter</strong>
            </h5>
            <p>
              If you accept an invitation from a host to play a Squad Play
              Challenge, the host will be able to see certain information about
              you in their Host portal. For example, they can see your email
              address, secret identity and avatar. For Challenges they’ve hosted
              only, they can see the days you Won the Day, Challenges completed,
              and skill badges earned. To protect your privacy, the host cannot
              see anything that you write in your Notes in the app, any custom
              activities you create, or information that is not related to
              Challenges they host.
            </p>
            <h5>
              <strong>How SuperBetter Shares Information</strong>
            </h5>
            <p>
              SuperBetter shares your information in the following
              circumstances:
            </p>
            <p>
              <strong>With your consent:</strong> We will share personal
              information with companies, organizations or individuals outside
              of SuperBetter when we have your consent to do so.
            </p>
            <p>
              <strong>For external processing:</strong> SuperBetter provides
              personal and non-personal information to our partners, trusted
              organizations, vendors and other affiliated organizations to
              process on our behalf. Our providers process data in accordance
              with our instructions, Privacy Notice and any other appropriate
              confidentiality, security or other requirements we deem necessary
              in order to comply with SuperBetter’s obligations.
            </p>
            <p>
              <strong>
                To respond to legal and other requests and to prevent harm:
              </strong>{" "}
              SuperBetter will share all categories of personal information with
              companies, organizations or individuals outside of SuperBetter if
              we have a good-faith belief that access, use, preservation or
              disclosure of the information is reasonably necessary to:
            </p>
            <ul>
              <li>
                <p>
                  Respond to or meet any applicable law, regulation, legal
                  process or other enforceable governmental request.
                </p>
              </li>
              <li>
                <p>
                  Enforce our Terms of Service, including investigation of
                  potential violations.
                </p>
              </li>
              <li>
                <p>
                  Detect, prevent, or otherwise address fraud, security or
                  technical issues.
                </p>
              </li>
              <li>
                <p>
                  Protect against and prevent harm to the rights, property or
                  safety of our users, SuperBetter, or the public as required or
                  permitted by law.
                </p>
              </li>
            </ul>
            <p>
              <strong>
                With any successor to all or part of our business:
              </strong>{" "}
              If SuperBetter is involved in a merger, acquisition, or sale of
              all or a portion of its assets, you will be notified via email
              and/or a notice on our website of any change in ownership or uses
              of your personal information, as well as any choices you may have
              regarding your personal information.
            </p>
            <p>
              <strong>For research purposes:</strong> From time to time,
              SuperBetter may release non-personal information in the aggregate
              or as part of anonymized datasets, for example, to be used in
              research studies evaluating the Service.
            </p>
            <h5>
              <strong>Your Choices About How We Use Your Information</strong>
            </h5>
            <h5>
              <strong>Promotional Communications</strong>
            </h5>
            <p>
              You may receive promotional email messages from SuperBetter when
              you first interact with the Service or by making a request to us.
              You can opt out of receiving promotional email messages from
              SuperBetter at the time we collect your information by following
              the instructions on screen, in those email messages, or by
              changing your notification settings in your SuperBetter account.
              Opting out of receiving communications may impact your use of the
              Services. If you decide to opt out, we will still send you
              non-promotional communications, such as messages about your
              account or our ongoing business relations.
            </p>
            <p>
              When you create an account you are given the option to receive a
              periodic newsletter from SuperBetter for news, tips and updates.
              You may subscribe or unsubscribe from the newsletter at any time
              by changing the settings in your account profile. You can also
              unsubscribe using the unsubscribe link located at the bottom of
              each newsletter.
            </p>
            <h5>
              <strong>Managing Your Account</strong>
            </h5>
            <p>
              You remain in control of the information you provide to
              SuperBetter. You may review, edit or delete any information you
              submit to us at any time by signing into your SuperBetter account;
              however, deletion of this information may restrict your ability to
              effectively use the Service. You may also delete your account at
              any time. If you delete your account, the account history and any
              activities created will also be also deleted in accordance with
              our data retention practices.
            </p>
            <h5>
              <strong>EU Resident Rights</strong>
            </h5>
            <p>
              SuperBetter processes your personal data only when we have a
              lawful basis for doing so. For example, some information we
              collect from is used to enable delivery of the Service and fulfill
              our agreement under the Terms of Service found on the Website,
              sometimes we collect and process your data when you have given us
              consent to do so, sometimes we are required by law and regulations
              to collect and process this information about you, and, at other
              times, we consider it to be in our legitimate interest to collect
              and process this information, taking into consideration your
              privacy rights. In rare cases we also may be required to process
              your data to protect your vital interests or for a task in the
              public good.
            </p>
            <p>
              European users also have several rights under the General Data
              Protection Regulation in certain circumstances, including the
              right to access, update and remove your personal data, object to
              particular processing, or file a complaint with our privacy team
              or a supervisory authority.
            </p>
            <p>
              The easiest way to remove all of your account’s personal data by
              using the delete account function in your account settings.
            </p>
            <p>
              For GDRP inquiries, contact our privacy team at SuperBetter, LLC,
              535 Duane Street, Floor 1.5, Glen Ellyn, IL 60137 or
              privacy@superbetter.com.
            </p>
            <h5>
              <strong>California and Nevada Resident Rights</strong>
            </h5>
            <p>
              <strong>California resident rights:</strong> If you reside in
              California and are not a job applicant, employee, or employee of
              another company interacting with us in your job role, you have the
              right to request what information we collect, use, and disclose.
              You also have the right to request that we delete your
              information. The easiest way is to log in to your account and
              delete your account using the option available on your Settings
              page. To make a request through our support team, use the support
              contact information found on the Contact us page of the website or
              the Support tab in your SuperBetter account profile. For requests
              submitted through our support team, we may need to take additional
              steps to verify you are the owner of the account, including
              confirming certain account information and ownership of the email
              address linked to the account. We will not discriminate against
              you because you have exercised any of your privacy rights under
              the California Consumer Privacy Act. You can designate an agent to
              make a request by having them execute a notarized power of
              attorney to act on your behalf.
            </p>
            <p>
              <strong>Sales of personal information:</strong> Under California
              law, we are required to tell California residents if we “sell”
              information as that term is defined by applicable law. “Sell”
              means to share personal information with a third party for
              monetary or other valuable consideration. Based on our
              understanding of that term, we do not sell your personal
              information. We also have disclosure obligations in Nevada. We do
              not exchange Nevada residents’ personal information for money with
              anyone so they may license or sell the personal information to
              additional parties. We do not sell personal information of minors
              under the age of 16.
            </p>
            <h5>
              <strong>How Long We Retain Your Information</strong>
            </h5>
            <p>
              SuperBetter retains your personal information for as long as your
              account is active, to fulfill our legitimate business purposes, or
              to comply with our legal obligations. When these conditions no
              longer exist, SuperBetter removes the information in accordance
              with our standard deletion processes. SuperBetter may retain and
              use non-personal information, including information which has been
              de-identified, aggregated, or anonymized, indefinitely.
            </p>
            <p>
              We retain records of support tickets and other communications
              between SuperBetter and our users, for example support emails,
              survey responses, or feedback submissions, indefinitely in order
              to better manage our support processes, maintain accurate business
              records, and identify other trends.
            </p>
            <h5>
              <strong>How We Protect Your Information</strong>
            </h5>
            <p>
              The security of your personal information is important to us.
              SuperBetter takes measures reasonably designed to protect against
              the unauthorized access, use, alteration or destruction of
              personal information.
            </p>
            <p>
              We use our best efforts to follow generally accepted industry
              standards to protect the personal information submitted to us,
              both during transmission and once we receive it. For example,
              SuperBetter data is encrypted in motion and when at rest, and we
              use different account authorizations to limit access to user
              personal information to only authorized team members who require
              access to perform their role.
            </p>
            <h5>
              <strong>Updates to this Privacy Policy</strong>
            </h5>
            <p>
              By accessing or using any part of the Service, you represent that
              you have read, understood, and agree to be bound by this Privacy
              Policy including any future modifications. SuperBetter may amend,
              update or change Privacy Policy. If we do this, we will post a
              notice that we have made changes to this Privacy Policy on the
              SuperBetter Website for at least 7 days after the changes are
              posted and will indicate at the bottom of the Privacy Policy the
              date the policy was last revised. Any revisions to the Privacy
              Policy will become effective the earlier of (i) the end of such
              7-day period or (ii) the first time you access or use the Service
              after such changes. If you do not agree to abide by the Privacy
              Policy you are not authorized to use, access or participate in the
              Service.
            </p>
            <p>Last revised on February 1, 2023</p>
          </Col>
        </Row>
      </div>
    </section>
  )
}

export default PrivacyPolicy1
